'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _radio = require('../components/radio');
var _radio2 = _interopRequireDefault(_radio);
var _input = require('../components/input');
var _input2 = _interopRequireDefault(_input);
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
VehicleOwner.propTypes = {
  relationOptions: _propTypes.array
};
VehicleOwner.defaultProps = {
  relationOptions: []
};
function VehicleOwner(props) {
  return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_radio2.default, {
    name: 'ownerRelation',
    label: 'Who owns the car?',
    options: props.relationOptions
  }), _react2.default.createElement(_input2.default, {
    name: 'owner',
    label: props.label ? props.label : "Main driver’s name"
  }));
}
exports.default = VehicleOwner;